import { render, staticRenderFns } from "./DefaultPrinter.vue?vue&type=template&id=31d2da47&scoped=true"
import script from "./DefaultPrinter.vue?vue&type=script&lang=js"
export * from "./DefaultPrinter.vue?vue&type=script&lang=js"
import style0 from "./DefaultPrinter.vue?vue&type=style&index=0&id=31d2da47&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d2da47",
  null
  
)

export default component.exports